/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
// export const urls="http://47.104.173.17:9002/evaluate"

// export const urls = 'http://test.api.51xiaoping.com/evaluate' //测试环境
// export const zpUrl = 'http://beta.zp.51xiaoping.com/#/'
// export const zpUrl = "http://localhost:8080/#/"

export const urls = 'https://api.51xiaoping.com/evaluate' //正式环境
export const zpUrl = 'http://xspj.51xiaoping.com/#/'

// export const urls = "http://192.168.0.142:9002/evaluate"
import { POST, BASE_URL, down } from '../api/index'
//退出登录
export function UserLogout() {
  return POST(urls + '/user/logout', '', 'post', '')
}
//获取登陆用户信息
export function usercenterinfo() {
  return POST(urls + '/usercenter/get-info', '', 'get', '')
}
// 保存密保信息
export function setQuestions(params) {
  return POST(urls + '/user/set-questions', params, 'post', '')
}
// 忘记密码 1 验证账号
export function forgetCheckuser(params) {
  return POST(urls + '/user/forget-checkuser', params, 'post', '', '4')
}
// 忘记密码 2 修改密码
export function forgetModifyPassword(params) {
  return POST(urls + '/user/forget-modify-password', params, 'post', '')
}
//获取学校详细信息
export function schoolgetinfo(params) {
  return POST(urls + '/school/get-info', params, 'get', '')
}
//获取在线课堂日历课程表
export function courseonlinelist(params) {
  return POST(urls + '/course/on-line/list', params, 'get', '')
}
// 教材获取学科列表
export function getSubjectList(params) {
  return POST(urls + '/course/subject/list', params, 'get', '')
}
// 获取课程列表
export function getCourseList(params) {
  return POST(urls + '/course/list', params, 'get', '')
}
//用户登录接口
export function userlogin(params) {
  return POST(urls + '/user/login', params, 'post', '', 4)
}
//获取登陆用户信息
export function usercentergetinfo(params) {
  return POST(urls + '/usercenter/get-info', params, 'get', '')
}
// 获取角色权限菜单
export function userpermissions(params) {
  return POST(urls + '/menu/tree-by-role', params, 'get', '')
}
//查询自己全部角色权限菜单
export function userpermissionsall(params) {
  return POST(urls + '/menu/tree-by-user', params, 'get', '')
}
// 获取路径
export function fileSever(params) {
  return POST(urls + '/file/server', params, 'get', '')
}
// 获取地域区域
export function areaList(params) {
  return POST(urls + '/area/list', params, 'get', '')
}
// 文件上传
export function fileUpload(params) {
  return POST(urls + '/file/oss-upload', params, 'post', '')
}

// 获取教育单位区域
export function orgList(params) {
  return POST(urls + '/org/list', params, 'get', '')
}

//获取学校类型列表
export function getSchoolTypeList(params) {
  return POST(urls + '/school/getschooltypelist', params, 'get', '')
}

// 修改或添加学校信息
export function postSchool(params) {
  return POST(urls + '/school', params, 'post', '')
}

//////////////////// 班级管理页面所需API ////////////////////////////

// 获取年级列表带班级数量
export function gradeList(params) {
  return POST(urls + '/grade/list', params, 'get', '')
}

// 获取班级列表
export function classesList(params) {
  return POST(urls + '/classes/list', params, 'get', '')
}

// 添加班级
export function addBatchcreate(params) {
  return POST(urls + '/classes/batchcreate', params, 'post', '')
}

// 获取教师列表
export function teacherLists(params) {
  return POST(urls + '/teacher/list', params, 'get', '')
}

// 设置班级班主任
export function classSetTeacher(params) {
  return POST(urls + '/classes/set-headteacher', params, 'post', '')
}

// 取消班主任
export function cancleTeacher(params) {
  return POST(urls + '/classes/cancel-headteacher', params, 'post', '', 4)
}

// 编辑班级
export function updateClasses(params) {
  return POST(urls + '/classes', params, 'post', '')
}

// 重置密码
export function resetPassword(params) {
  return POST(urls + '/usercenter/reset-password', params, 'get', '')
}

// 删除教师
export function deleteTeacher(params) {
  return POST(urls + '/teacher/' + params, '', 'delete', '')
}

// 教师分配角色
export function roleUser(params) {
  return POST(urls + '/role/user', params, 'post', '', 4)
}

// 编辑教师
export function addEditor(params) {
  return POST(urls + '/teacher', params, 'post', '')
}

// 根据学校ID获取年级列表
export function gradeClassList(params) {
  return POST(urls + '/grade/gradelist', params, 'get', '')
}

// 获取全部学科列表
export function subjectList(params) {
  return POST(urls + '/subject/list', params, 'get', '')
}

// 导出教师excel表格
export function dexportTeacher(params, name) {
  return down(urls + '/export/teacher?schoolId=' + params, 'get', name)
}

// 查询角色
export function roleList(params) {
  return POST(urls + '/role/list', params, 'get', '')
}

//删除该角色的用户
export function deletdRoleUser(params) {
  return POST(urls + '/role/user', params, 'delete', '')
}

//校验是否已经设置分工
export function WorkCheckSubject(params) {
  return POST(urls + '/teacher/work/check_subject', params, 'post', '')
}

// 保存教师分工
export function teacherWorkSetting(params) {
  return POST(urls + '/teacher/work/setting', params, 'post', '')
}

/////////////// 学生相关API////////////////////

//查询学生信息
export function studentList(params) {
  return POST(urls + '/student/list', params, 'get', '')
}

// 删除学生
export function deletdStudent(params) {
  return POST(urls + '/student/' + params, '', 'delete', '')
}

// 保存学生和家长
export function saveStudent(params) {
  return POST(urls + '/student', params, 'post', '')
}

// 家长手机号验证
export function checkParentPhone(params) {
  return POST(urls + '/student/check-parent', params, 'post', '')
}

// 解除家长绑定
export function studentUnbindParent(params) {
  return POST(urls + '/student/unbindParent', params, 'post', '', 4)
}

// 导出学生信息
export function dexportStudent(params, name) {
  return down(
    urls +
      '/export/student?schoolId=' +
      params.schoolId +
      '&gradeId=' +
      params.gradeId +
      '&classesId=' +
      params.classesId +
      '&studentTemplateType=' +
      params.studentTemplateType,
    'get',
    name
  )
}

// 字典
export function dictCode(params) {
  return POST(urls + '/dict/code', params, 'get', '')
}

// 家长手机号验证
export function studentCheckParent(params) {
  return POST(urls + '/student/check-parent', params, 'post', '')
}

// 新增/修改家长
export function studentSaveParent(params) {
  return POST(urls + '/student/save-parent', params, 'post', '')
}

//查询学生信息
export function getInfoByIdCard(params) {
  return POST(urls + '/student/getInfoByIdCard', params, 'get', '')
}

//学生转校-保存
export function saveTransferInfo(params) {
  return POST(urls + '/student/saveTransferInfo', params, 'post', '')
}

// 获取教师所选教材列表
export function getBookList(params) {
  return POST(urls + '/prepare/book/list', params, 'get', '')
}

// 删除教材
export function deleteBook(params) {
  return POST(urls + '/prepare/book/' + params, '', 'delete', '')
}

// 获取教材版本
export function getVersionList(params) {
  return POST(urls + '/book/version/list', params, 'get', '')
}

// 获取全部学科列表
export function getBookSubjectList(params) {
  return POST(urls + '/subject/list', params, 'get', '')
}

// 获取年级分类
export function getVolumeList(params) {
  return POST(urls + '/book/volume/list', params, 'get', '')
}

// 获取教材章节树
export function getChaptertreeVo(params) {
  return POST(urls + '/book/get-chaptertree-vo', params, 'get', '')
}

// 添加书籍
export function addBook(params) {
  return POST(urls + '/prepare/book', params, 'post', '')
}

// 获取我的应用列表
export function getMyappList(params) {
  return POST(urls + '/usercenter/get-myapp-list', params, 'get', '')
}

//修改密码
export function modifyPassWord(params) {
  return POST(
    urls + '/usercenter/modify-password-by-old',
    params,
    'post',
    '',
    '4'
  )
}

//获取教师详情
export function teacherData(id, params) {
  return POST(urls + '/teacher/' + id, params, 'get', '')
}
// 获取角色信息
export function roleByUser(params) {
  return POST(urls + '/role/list/by-user', params, 'get', '')
}
// 获取角色信息
export function wxauthLogin(params) {
  return POST(urls + '/user/qy/wx/authLogin', params, 'post', '')
}

//年级列表
export function gradegradelist(params) {
  return POST(urls + '/grade/gradelist', params, 'get', '')
}

//评价指标-获取学校某个等级下所有指标
export function nodesgetListByLevel(params) {
  return POST(urls + '/nodes/getListByLevel', params, 'get', '')
}
//获取学校所有科室
export function schoolgetdepartmentlist(params) {
  return POST(urls + '/school/getdepartmentlist', params, 'get', '')
}
//学校课程--保存
export function schoolCoursesaveSchoolCourse(params) {
  return POST(urls + '/schoolCourse/saveSchoolCourse', params, 'post', '')
}
//学校课程--查询学校课程
export function schoolCoursequerySchoolCourse(params) {
  return POST(urls + '/schoolCourse/querySchoolCourse', params, 'get', '')
}
//学校课程--删除
export function schoolCoursedelSchoolCourse(params) {
  return POST(
    urls + '/schoolCourse/delSchoolCourse?courseId=' + params.courseId,
    '',
    'post',
    ''
  )
}
//开启课程
export function schoolCourseisOpen(params) {
  return POST(urls + '/schoolCourse/isOpen', params, 'get', '')
}
//获取系统通用模板
export function getSchoolTemplate() {
  return POST(urls + '/template/getTemplateShow', '', 'get', '')
}
//获取学校配置进度
export function getSchoolConfigStep() {
  return POST(urls + '/schoolCardPrint/getSystemCardPrintItems', '', 'get', '')
}
/// 保存指标模板
export function saveTargetTemplate() {
  return POST(urls + '/schoolCardPrint/saveSysIndex', '', 'post', '')
}
//保存课程开设  /evaluate/schoolCardPrint/saveSystemCourseOffering
export function saveCourse(params) {
  return POST(
    urls + '/schoolCardPrint/saveSystemCourseOffering',
    params,
    'post',
    ''
  )
}
//获取课程开设情况
export function schoolClassSatution(params) {
  return POST(
    urls + '/schoolCardPrint/getSystemCourseOffering',
    params,
    'get',
    ''
  )
}
//获取学校模板信息
export function getSchoolTemplateMsg(params) {
  return POST(urls + '/template/getTemplate', params, 'get', '')
}
//保存课程行为和目标 /schoolCardPrint/saveSchoolCoursePoint
export function saveCourseBehaviorAndTarget(params) {
  return POST(
    urls + '/schoolCardPrint/saveSchoolCoursePoint',
    params,
    'post',
    ''
  )
}
//保存课程观测点进度 Save Course Observations
export function saveCourseObservations() {
  return POST(urls + '/schoolCardPrint/keyBehaviors', '', 'post', '')
}
// 接受请求凭证
export function requestIdtrans(params) {
  return POST(urls + '/integrate/requestId/trans', params, 'post', '')
}
// 联系咨询
export function saveContactConsultation(params) {
  return POST(
    urls + '/contactConsultation/saveContactConsultation',
    params,
    'post',
    ''
  )
}
//seed国家综评
export function secretFreeLogin(params) {
  return POST(urls + '/seed/secretFreeLogin', params, 'get', '')
}



// WEBPACK FOOTER //
// ./src/api/home.js